<template>
  <div class="my-weiper-container" :class="{'my-weiper-container-mob': !isPC}">
    <!-- <div class="title" v-if="!isPC">美图鉴赏</div> -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :class="{'swiper-slide-mob': !isPC}" v-for="(item,index) in imgList" :key="index">
          <!-- <img v-img-lazy="item" alt="" :data-index="index" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`"> -->
          <img v-img-lazy="item" v-if="shouldLazy(index)" alt="" :data-index="index" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`">
          <img :src="item" v-else alt="" :data-index="index" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`">
        </div>
      </div>
      <div
        v-if="!isPC && imgList && imgList.length>1"
        class="swiper-button-next"
        :class="{'swiper-button-mob': !isPC}"
        id="swiper-button-next"
        :code-stm="`event, PAGEURL页面, 轮播下一页`"
      >
      </div>
      <div
        v-if="!isPC && imgList && imgList.length>1"
        class="swiper-button-prev"
        :class="{'swiper-button-mob': !isPC}"
        id="swiper-button-prev"
        :code-stm="`event, PAGEURL页面, 轮播上一页`"
      >
      </div>
      <div class="swiper-pagination" :class="{'swiper-pagination-mob': !isPC}"></div>
    </div>

    <div class="cover" v-if="isShowCover">
      <i class="el-icon-close" :class="{'el-icon-close-mob': !isPC}" @click="hideCover" :code-stm="`event, PAGEURL页面, 关闭弹窗`"></i>
      <div class="pop">
        <div class="swiper-container2" :class="{'swiper-container2-mob': !isPC}">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in imgList" :key="index+'cover'">
              <img :src="item" alt="">
              <!--
              <img v-img-lazy="item" v-if="index >= 2" alt="" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`">
              <img :src="item" v-else alt="" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`"> -->
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination swiper-pagination2"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next swiper-button-next2" :code-stm="`event, PAGEURL页面, 弹窗轮播下一页`"></div>
        <div class="swiper-button-prev swiper-button-prev2" :code-stm="`event, PAGEURL页面, 弹窗轮播上一页`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      imgList: [],
      imgListPc: [

        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p14.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p15.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p16.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p17.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p18.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p19.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p22.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p23.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p26.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p1.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p2.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p3.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p4.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p5.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p6.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p7.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p8.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p9.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p10.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p11.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p12.png',
      ],
      imgListMob: [

        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p14.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p15.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p16.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p17.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p18.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p19.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p22.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p23.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p26.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p1.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p2.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p3.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p4.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p5.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p6.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p7.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p8.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p9.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p10.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p11.png',
        'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/imgswiper/p12.png'
      ],
      isShowCover: false,
      swiperCover: null
    };
  },
  mounted: function () {
    this.imgList = !this.isPC ? this.imgListMob : this.imgListPc
    this.$nextTick(()=> {
      if (this.isPC) {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 2.5,
          spaceBetween: 40,
          centeredSlides: false,
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
          },
          mousewheel: true
        });
        window.addEventListener("click", this.showCover)
      } else {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '#swiper-button-next',
            prevEl: '#swiper-button-prev',
          },
        });
        window.addEventListener("click", this.showCover)
      }
      this.swiperCover = new Swiper('.swiper-container2', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: '.swiper-pagination2',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2',
        },
      });
    })
  },
  methods: {
    shouldLazy(index) {
      return index >= 2 && index < this.imgList.length - 1;
    },
    showCover(e) {
      const index = e.target.getAttribute('data-index')
      console.log(index);
      if (index) {
        this.isShowCover = true
        this.$nextTick(()=> {
          this.swiperCover = new Swiper('.swiper-container2', {
            initialSlide: index,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: '.swiper-pagination2',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next2',
              prevEl: '.swiper-button-prev2',
            },
          });
        })
        window.removeEventListener("click",this.showCover)
        //开始全屏预览
        window.parent.postMessage({ type: 'ev6ImgSwiperOpen' }, '*')
      }
    },
    hideCover() {
      this.isShowCover = false
      this.swiperCover = null
      window.addEventListener("click", this.showCover)
        //关闭全屏预览
      window.parent.postMessage({ type: 'ev6ImgSwiperClose' }, '*')
    }
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";
.my-weiper-container {
  position: relative;
  height: 100%;
  width: 100%;
  user-select: none;
  padding-bottom: 20px;
  padding: 0 6%;
  display: flex;
  align-items: center;
  img{
    width: 100%;
    height: auto;
  }
  .swiper-container {
	  position: relative;
    width: 100%;
    height: auto;
    padding-bottom: 45px;
    /* overflow: visible; */
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms;
    cursor: pointer;
    &-mob {
      transform: scale(1);
    }
  }
  .swiper-slide-active,.swiper-slide-duplicate-active{
   transform: scale(1);
  }
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: -45px;
  }
  .swiper-container-horizontal > .swiper-pagination-progressbar, .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    top: unset;
    height: 2px;
    bottom: 0;
  }
  ::v-deep .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #05141f!important;
  }
  ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
    .swiper-pagination-bullet {
      width: 32px;
      height: 2px;
      background: #05141F;
      border-radius: 0;
    }
    .swiper-pagination-bullet-active {
      width: 48px;
    }
  }
  .swiper-button-next, .swiper-button-prev {
    width: 2.91666vw;
    height: 2.91666vw;
    background: rgba($color: #fff, $alpha: 0.8);
    transition: all .5s;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    transform: translateY(-50%);
    &::after {
      /* content: none; */
      font-size: 16px;
      font-weight: 900;
      color: rgba(5, 20, 31, 0.8);
    }
    &:hover {
      background: rgba($color: #05141F, $alpha: 0.8);
    }
    &:hover::after {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .swiper-button-prev, .swiper-button-next:focus {
    outline: none;
  }
  .swiper-button-next {
      right: 2%;
  }
  .swiper-button-prev {
      left: 2%;
  }
  &-mob {
    padding: 0;
    .title {
      padding: 10px 5%;
      font-size: 28px;
    }
    .swiper-container {
      padding: 0;
    }
    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -20px;
    }
    ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
      .swiper-pagination-bullet {
        width: 8px;
        height: 2px;
        background: #05141F;
        border-radius: 0;
      }
      .swiper-pagination-bullet-active {
        width: 16px;
      }
    }
    .swiper-button-mob {
      width: 30px;
      height: 30px;
      background: rgba($color: #000000, $alpha: 0);
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(0);
      &::after {
        font-size: 16px;
        font-weight: 900;
        color: #fff;
      }
      &:hover {
        background: rgba($color: #000000, $alpha: 0);
      }
      &:hover::after {
        color: #fff;
      }
    }
  }
  /* @media screen and (orientation: portrait) {
    padding: 20px 0 25px;
    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -20px;
    }
  } */

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 10;
    .el-icon-close {
      color: #fff;
      font-size: 40px;
      cursor: pointer;
      position: absolute;
      z-index: 99;
      right: 50px;
      top: 50px;
      &-mob {
        font-size: 30px;
        right: 20px;
      }
    }
    .pop {
      position: relative;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .swiper-container2 {
      width: 70vw;
      height: auto;
      overflow: hidden;
      /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
      /* height: 80%; */
      .swiper-slide {
        background: rgba($color: #000000, $alpha: 0);
        img {
          width: 78%;
          height: auto;
        }
        @media (max-width: 768px) {
          img {
            width: 100%;
          }
        }
      }
      &-mob {
        width: 100vw;
      }
    }
    .swiper-pagination-fraction {
      position: absolute;
      z-index: 999;
      bottom: -30px;
      color: #fff;
    }
    .swiper-button-next, .swiper-button-prev {
      background: rgba($color: #000, $alpha: 0);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);
      &::after {
        /* content: none; */
        font-size: 30px;
        font-weight: 400;
        color: #fff;
      }
      &:hover {
        background: rgba($color: #05141F, $alpha: 0);
      }
      &:hover::after {
        color: #fff;
      }
    }
    .swiper-button-prev, .swiper-button-next:focus {
      outline: none;
    }
    .swiper-button-next2 {
        right: 0;
        transform: translateY(-25%);
    }
    .swiper-button-prev2 {
        left: 0;
        transform: translateY(-25%);
    }
    @media (max-width: 768px) {
      .swiper-button-next2 {
          width: auto;
          height: auto;
          right: 2%;
          transform: translateY(25%);
      }
      .swiper-button-prev2 {
          width: auto;
          height: auto;
          left: 2%;
          transform: translateY(25%);
      }
    }
  }
}
</style>
